import { render } from "./TicketComplete.vue?vue&type=template&id=f0b53eac&scoped=true"
import script from "./TicketComplete.vue?vue&type=script&lang=js"
export * from "./TicketComplete.vue?vue&type=script&lang=js"

import "./TicketComplete.vue?vue&type=style&index=0&id=f0b53eac&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f0b53eac"

export default script